import {
  BodyText,
  Flex,
  IconButton,
  InputSlot,
  TextInput,
} from '@utilitywarehouse/hearth-react';
import { TrashSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import { type ChangeEvent, useCallback } from 'react';

import { BrandLogo } from '@features/Cashback/Calculator/BrandLogo/BrandLogo';
import { RetailPartner } from '@generated/gql/graphql';

import './styles.scss';

interface BrandProps {
  brand: RetailPartner;
}

const Brand = ({ brand }: BrandProps) => {
  return (
    <Flex alignItems="stretch" className="brandEntry__Brand">
      <BrandLogo brand={brand} />
      <div className="brandEntry__BrandDiscount">
        <BodyText size="lg" weight="semibold">
          {Math.round(brand.discount * 100)}%
        </BodyText>
      </div>
    </Flex>
  );
};

interface BrandEntryProps {
  brand: RetailPartner;
  value: number;
  onChange: (brandId: string, value: number) => void;
  onDelete: () => void;
}

const BrandEntry = ({ brand, value, onChange, onDelete }: BrandEntryProps) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      let v = parseInt(inputValue, 10);

      // should handle where input value is empty string
      // or starts with characters
      if (isNaN(v)) v = 0;

      onChange(brand.id, v);
    },
    [brand.id, onChange]
  );

  return (
    <Flex
      direction="row"
      alignItems="center"
      justifyContent="between"
      spacing="lg"
    >
      <div className="brandEntry__Container">
        <Brand brand={brand} />

        <div className="brandEntry__Label">
          <BodyText weight="semibold">{brand.name}</BodyText>
          <BodyText size="sm" color="secondary">
            {brand.category}
          </BodyText>
        </div>
        <div className="brandEntry__Input">
          <TextInput
            label="spend amount"
            name={brand.id}
            hideLabel
            onChange={handleChange}
            value={value}
          >
            <InputSlot placement="prefix">
              <BodyText weight="semibold">£</BodyText>
            </InputSlot>
          </TextInput>
        </div>
        <div className="brandEntry__Action">
          <IconButton
            type="button"
            colorScheme="destructive"
            variant="ghost"
            size="sm"
            label="remove"
            onClick={onDelete}
          >
            <TrashSmallIcon />
          </IconButton>
        </div>
      </div>
    </Flex>
  );
};

export { BrandEntry, type BrandEntryProps };
